"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockShopifyProduct = void 0;
const shopify_variant_1 = require("./shopify_variant");
function mockShopifyProduct(overrides = {}) {
    return {
        description: 'mock product description',
        descriptionHtml: '<p>mock product description</p>',
        handle: 'mock-handle',
        id: 'mock-product-id',
        options: [
            {
                name: 'Size',
                values: ['1'],
            },
        ],
        productType: 'mocks-tests',
        tags: [],
        title: 'mock product title',
        vendor: 'mock vendor',
        variants: {
            edges: [
                {
                    node: (0, shopify_variant_1.mockShopifyVariant)(),
                },
            ],
        },
        ...overrides,
    };
}
exports.mockShopifyProduct = mockShopifyProduct;
